"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  is5xx: function is5xx(response) {
    if (response && response.status && (response.status === 503 || response.status === 504)) return true;
    return false;
  },
  isNetworkError: function isNetworkError(response) {
    return response instanceof Error;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/json-fetch/lib/retriers.js
// module id = 514
// module chunks = 0